import React from 'react'
import "./Common_heading.css"

function Common_heading({title,subTitle}) {
    return (
        <>
            <section className='common_heading_holder'>
                <h3>{title}</h3>
                <h4>{subTitle}</h4>
            </section>
        </>
    )
}

export default Common_heading